import { useEffect } from 'react';
import ContainerComponent from '@/components/common/notes/show-note-forms/form-components/container-component';
import { SET_VALUE } from '@/components/common/notes/show-note-forms/dataToSendReducer';
import { FormControl, Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import decodeHtmlEntities from '@/utils/decodeHtmlEntities';

interface Props {
    value: string;
    formId: string;
    formName: string;
    formDispatch: any;
    item: {
        label: string;
        name: string;
        placeholder: string;
        subtype: string;
        required: boolean;
        values: any[];
        description: string;
    };
    readOnly: boolean;
}

const SelectFieldComponent = ({
    value,
    formDispatch,
    formId,
    formName,
    item: { label, values, name: fieldId, required, description },
    readOnly,
}: Props) => {
    useEffect(() => {
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    }, []);

    const handleChange = ({ target: { value } }: any) => {
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    };

    return (
        <ContainerComponent label={label} required={required} description={description}>
            <FormControl sx={{ width: '100%' }}>
                <Select
                    value={value}
                    onChange={handleChange}
                    sx={{ fontSize: 14 }}
                    disabled={readOnly}
                    variant='standard'
                >
                    {values.map(({ value, label }) => (
                        <MenuItem key={label} value={value} sx={{ fontSize: 14 }}>
                            {decodeHtmlEntities(label)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </ContainerComponent>
    );
};

export default SelectFieldComponent;
